import { useEffect, useRef, type ReactElement, type ReactNode } from 'react';
import { Modal } from '@engie-group/fluid-design-system';
import CenterModal from '@shared/modal/CenterModal';

export function Dialog({ id, title, children, footer, onClose }: {
  id: string; title: string; children: ReactNode; footer?: ReactElement; onClose: () => void;
}) {
  const opener = useRef(document.activeElement);
  useEffect(() => {
    const element = document.getElementById(id);
    if (!element) return;
    Modal.init();
    const instance = Modal.getInstance(element);
    instance.show();
    return () => {
      instance.hide();
      instance.dispose();
      if (opener.current instanceof HTMLElement) opener.current.focus();
    };
  }, [id]);
  const hide = () => {
    const element = document.getElementById(id);
    if (element) Modal.getInstance(element)?.hide();
  };
  return <CenterModal dataTarget={id} title={title} className="pav-dialog"
    onClick={hide} onHide={onClose} body={<div className="pav-stack">{children}</div>} footer={footer} />;
}
